// extracted by mini-css-extract-plugin
export default {"Login":"Login_Login__ILlr0","LoginBox":"Login_LoginBox__jnb0c"};